import { IRequirementEntityAttributes, PlanSelectionEntity, TermEntity } from 'Models/Entities';
import { DataIndex, indexByPropertyMutate } from 'Util/DataIndexUtils';
import { getRequirementComponents } from 'Util/RequirementEntityUtils';

export const indexTermsByStudyPeriods = (terms: TermEntity[]) => {
	return indexByPropertyMutate<TermEntity, TermEntity[]>(
		terms,
		term => term.studyPeriod.id,
		(curr, acc) => {
			if (acc) {
				const existingTerm = acc.find(t => t.id === curr.id);

				if (existingTerm) {
					return acc;
				}

				acc.push(curr);
				return acc;
			}

			return [curr];
		},
	);
};

/**
 * Get the components at the top of the tree for a given selected course
 * @param courseId
 * @param planSelections
 * @param requirementsById
 */
export const getSelectedCourseLocations = (
	courseId: string,
	planSelections: PlanSelectionEntity[],
	requirementsById: DataIndex<IRequirementEntityAttributes>,
) => {
	const courseSelections = planSelections
		.filter(planSelection => planSelection.courseId === courseId);

	return getRequirementComponents(
		courseSelections.map(selection => selection.locationId),
		requirementsById,
	);
};
